const NoAccess = () => (
  <div className="page-not-found">
    <h1>No Access</h1>
    <p>You have no authorization to use this application.</p>
  </div>
);

export default NoAccess;
